import { create } from 'zustand'

type ImageShape = 'circle' | 'rectangle'

type ImageSize = {
  width: number
  height: number
}

type StencilSize = {
  width: number
  height: number
}

type OpenPayload = {
  slotId: string
  imageUrl?: string
  imageShape?: ImageShape
  imageSize: ImageSize
  stencilSize: StencilSize
}

type CropImageState = {
  isOpen: boolean
  slotId: string | null
  imageUrl?: string
  imageShape?: ImageShape
  imageSize: ImageSize | null
  stencilSize: StencilSize | null
  open: (payload: OpenPayload) => void
  close: () => void
}

export const useCropImageStore = create<CropImageState>(set => ({
  isOpen: false,
  slotId: null,
  imageUrl: undefined,
  imageShape: 'rectangle',
  imageSize: null,
  stencilSize: null,
  open: ({ slotId, imageUrl, imageShape, imageSize, stencilSize }) =>
    set({
      isOpen: true,
      slotId,
      imageUrl,
      imageShape: imageShape ?? 'rectangle',
      imageSize,
      stencilSize
    }),
  close: () =>
    set({
      isOpen: false,
      slotId: null,
      imageUrl: undefined,
      imageSize: null,
      stencilSize: null
    })
}))
